import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { handleApiError } from "@utils/errorHandler";
import { WarningPopUp, Image } from "hesus-ui-kit";
import { ButtonContainer } from "./ProductAction.styled";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import activateIcon from "@icons/ic-activate.svg";
import AddEditProduct from "../../../AddEditProduct/AddEditProduct";
import "../../ProductsList.scss";

const ProductAction = (props) => {
  const { t, data, onRefreshData, updateRefeshStatus, countries } = props;
  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const [isEditMode, setIsEditMode] = useState(true);

  const [isEditProductPopupVisible, setIsEditProductPopupVisible] =
    useState(false);
  const handleProductDisable = () => {
    setConfirmVisibility(true);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };
  useEffect(() => {
    if (isConfirm) {
      const formStatus = data.status ? "0" : 1;
      axios
        .post(`/product/${data.id}/updateStatus`, formStatus)
        .then(() => {
          onRefreshData(true);
        })
        .catch((error) => handleApiError(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  const editProduct = () => {
    setIsEditProductPopupVisible(true);
  };

  const closeProductEditPopup = () => {
    setIsEditProductPopupVisible(false);
  };

  return (
    <ButtonContainer>
      <div>
        <Image
          src={editIcon}
          onClick={editProduct}
          title={t("PRODUCT_ACTION_TOOLTIP_EDIT")}
          alt={t("PRODUCT_ACTION_TOOLTIP_EDIT")}
          className="products-list__product-action-icon"
        />
        {data.status == 1 && (
          <Image
            src={deleteIcon}
            onClick={handleProductDisable}
            alt={t("PRODUCT_ACTION_TOOLTIP_DISABLE")}
            title={t("PRODUCT_ACTION_TOOLTIP_DISABLE")}
            className="products-list__product-action-icon"
          />
        )}
        {data.status == 0 && (
          <Image
            src={activateIcon}
            onClick={handleProductDisable}
            alt={t("PRODUCT_ACTION_TOOLTIP_ACTIVATE")}
            title={t("PRODUCT_ACTION_TOOLTIP_ACTIVATE")}
            className="products-list__product-action-icon"
          />
        )}
        {isEditProductPopupVisible && (
          <AddEditProduct
            id={data.id}
            title={t("PRODUCT")}
            onClose={closeProductEditPopup}
            isEditMode={isEditMode}
            updateRefeshStatus={updateRefeshStatus}
            countries={countries}
          />
        )}
      </div>

      {isConfirmVisible && (
        <WarningPopUp
          title={
            data.status == 0
              ? t("PRODUCT_CONFIRMATION_BOX_ENABLE")
              : t("PRODUCT_CONFIRMATION_BOX_DELETE")
          }
          message={
            data.status == 0
              ? t("PRODUCT_CONFIRMATION_BOX_ENABLE_CONTENT")
              : t("PRODUCT_CONFIRMATION_BOX_DELETE_CONTENT")
          }
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </ButtonContainer>
  );
};

ProductAction.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    canEdit: PropTypes.number,
  }).isRequired,
  t: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
};
export default withTranslation()(ProductAction);
